import { render, staticRenderFns } from "./CategroyList.vue?vue&type=template&id=2fe0b945&scoped=true"
import script from "./CategroyList.vue?vue&type=script&lang=js"
export * from "./CategroyList.vue?vue&type=script&lang=js"
import style0 from "./CategroyList.vue?vue&type=style&index=0&id=2fe0b945&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0b945",
  null
  
)

export default component.exports